import React from "react";
import { useNavigate } from "react-router-dom";
import Hero from '../components/Hero';
import Card from '../components/Card';
import { IconRocket, IconAI, IconFullStack } from '../components/Icons';
import './Home.css';

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="home mesh-gradient">
      <Hero title="Apres AI" subtitle="Transforming Ideas Into Reality" />

      <section className="cta-section animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
        <div className="cta-content glass">
          <p className="hero-description">
            We're an AI-forward development team that specializes in rapidly
            turning innovative ideas into viable businesses through cutting-edge
            web and mobile applications.
          </p>
          <div className="cta-buttons">
            <button
              className="cta-primary glass"
              onClick={() => navigate('/services')}
            >
              Get Started
            </button>
            <button
              className="cta-secondary glass"
              onClick={() => navigate('/about')}
            >
              Learn More
            </button>
          </div>
        </div>
      </section>

      <section className="features">
        <div
          className="features-content animate-fade-in-up"
          style={{ animationDelay: '0.4s' }}
        >
          <h3>What We Do</h3>
          <p className="features-subtitle">
            We transform innovative ideas into market-ready products using
            cutting-edge AI and modern development practices.
          </p>
          <div className="feature-grid">
            <Card
              variant="service"
              image="/images/rapid_dev_modern.webp"
              icon={<IconRocket />}
              title="Rapid Development"
              description="From concept to deployment in record time using modern frameworks and AI-assisted development."
            />
            <Card
              variant="service"
              image="/images/ai_solutions_modern.webp"
              icon={<IconAI />}
              title="AI-Powered Solutions"
              description="Leverage cutting-edge AI technologies to create intelligent, responsive applications."
            />
            <Card
              variant="service"
              image="/images/fullstack_modern.webp"
              icon={<IconFullStack />}
              title="Full-Stack Expertise"
              description="End-to-end development covering web, mobile, and cloud infrastructure."
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
